import { Component } from '@angular/core';
import { RouteParams } from '@angular/router-deprecated';
import { Response } from '@angular/http';
import { LoadingService } from '../services';
import { LoadIndicator } from '../common/LoadIndicator';
import { ResultExportService } from '../services';

@Component({
    selector: 'export',
    template: require('./export.html'),
    providers: [ResultExportService],
    directives: [],
})
export class ExportComponent {
    institutionId: number;
    complete = false;

    constructor(
        protected ResultExportService: ResultExportService,
        params: RouteParams,
        protected loadingService: LoadingService
    ) {
        this.institutionId = parseInt(params.get('id'));
    }

    exportResults() {
        this.complete = false;
        this.loadingService.startLoad();
        this.ResultExportService.export(this.institutionId).subscribe(data => this.downloadFile(data, this.institutionId));
    }

    downloadFile(data: Response, institutionId: number){
        let blob = new Blob([(<any> data)._body], { type: 'text/csv' });
        let link=document.createElement('a');
        link.href=window.URL.createObjectURL(blob);
        link["download"]=`outcomes_export_${institutionId}.csv`;
        link.click();
        this.loadingService.stopLoad();
    }
}


/** WEBPACK FOOTER **
 ** ./app/export/ExportComponent.ts
 **/